import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

const ALERT_TOAST_EVENT_NAMES = {
  ACCEPT_ALERT_FROM_TOAST: 'click_alert_toast_accept_button',
};

export const trackAcceptAlertFromToast = ({ alertID, irpVersion, isTest }) => {
  const buttonLabel = isTest ? 'ACCEPT TEST' : 'ACCEPT';

  gspx.trackEvent({
    name: ALERT_TOAST_EVENT_NAMES.ACCEPT_ALERT_FROM_TOAST,
    type: GPX_EVENT_TYPES.INFO,
    feature: GPX_FEATURES.LEGACY,
    capability: GPX_CAPABILITIES.LEGACY,
    route: GPX_ROUTES.CALL_QUEUE,
    additionalKeys: {
      legacy_category: 'Alert',
      legacy_name: `Click alert toast ${buttonLabel} button in RSP`,
      Category: 'Alert',
      'Launched date': new Date(),
      irpVersion,
    },
    entities: {
      alert_id: alertID,
    },
  });
};
